import api from "../api/config";
import { ENDPOINTS } from "../api/endpoints";

/**
 * Frontend API service for admin booking configuration.
 * Returns: { success: boolean, data?: object, error?: string, message?: string }
 */
export const zoomAdminService = {
  /**
   * Get all admin configurations.
   * 
   * @returns {Promise<Object>} { success: boolean, data: { adminConfigs: Array }, error?: string }
   */
  getAllAdminConfigs: async () => {
    try {
      const response = await api.get(ENDPOINTS.GET_ZOOM_ADMIN_CONFIG);
      return response.data;
    } catch (error) {
      // Extract error message from API response or use fallback
      const errorMessage = error?.response?.data?.error || error?.message || "Failed to fetch admin configurations";
      throw new Error(errorMessage);
    }
  },

  /**
   * Update admin configurations.
   * Backend validates: at least one active admin, inactive admins can't have priority.
   * 
   * @param {Object} data - { adminConfigs: Array }
   * @returns {Promise<Object>} { success: boolean, message?: string, data?: object, error?: string }
   */
  updateAdminConfigs: async (data) => {
    try {
      const response = await api.put(ENDPOINTS.UPDATE_ZOOM_ADMIN_CONFIG, data);
      return response.data;
    } catch (error) {
      // Extract error message from API response or use fallback
      const errorMessage = error?.response?.data?.error || error?.message || "Failed to update admin configurations";
      throw new Error(errorMessage);
    }
  },
};
